// file imports
import adminDashboardReducer from './slices/adminDashboardSlice';
import adminEventReducer from './slices/adminEventSlice';
import adminFeedbackReducer from './slices/adminFeedbackSlice';
import adminPresentationReducer from './slices/adminPresentationSlice';
import adminUserReducer from './slices/adminUserSlice';
import authReducer from './slices/authSlice';
import eventReducer from './slices/eventSlice';
import feedbackDetailReducer from './slices/feedbackDetailSlice';
import feedbackQuestionReducer from './slices/feedbackQuestionSlice';
import feedbackReducer from './slices/feedbackSlice';
import feedbackResponsesReducer from './slices/feedbackResponsesSlice';
import leadReducer from './slices/leadSlice';
import presentationReducer from './slices/presentationSlice';
import uploadReducer from './slices/uploadSlice';
import userReducer from './slices/userSlice';

const rootReducer = {
  auth: authReducer,
  event: eventReducer,
  presentation: presentationReducer,
  feedbackQuestion: feedbackQuestionReducer,
  feedback: feedbackReducer,
  feedbackDetail: feedbackDetailReducer,
  feedbackResponses: feedbackResponsesReducer,
  lead: leadReducer,
  upload: uploadReducer,
  user: userReducer,
  adminUser: adminUserReducer,
  adminDashboard: adminDashboardReducer,
  adminEvent: adminEventReducer,
  adminPresentation: adminPresentationReducer,
  adminFeedback: adminFeedbackReducer,
};

export default rootReducer;
